import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import App from 'components/App'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'utils/polyfills/url'

// EXPL: Catch chunk load errors and reload the page.
// They are usually caused by references to old resources (after new release), and simple reloading fixes them
window.addEventListener('error', (e: any) => {
  if (e?.message?.includes('Loading chunk')) {
    console.warn('Global chunk load error - reloading...')
    window.location.reload()
  }
})

window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  if (e.reason?.message?.includes('Loading chunk')) {
    console.warn('Unhandled chunk load error - reloading...')
    window.location.reload()
  }
})

if (__PROD__) {
  import('./pwa')
}

const container = document.getElementById('root') as HTMLElement
const root = createRoot(container)
root.render(createElement(App))
